import { requestJson } from '../../../shared/api/http'
import type {
  TopicList,
  CreateTopicListInput,
  UpdateTopicListInput,
  TopicsQuery,
} from '../model/contracts'
import {
  parseTopicList,
  parseTopicListResponse,
  type TopicListResponse,
} from './topicsCodec'

export async function fetchTopics(
  query: TopicsQuery = {},
  signal?: AbortSignal,
): Promise<TopicListResponse> {
  const params = new URLSearchParams()
  if (query.page) params.append('page', query.page.toString())
  if (query.limit) params.append('limit', query.limit.toString())
  if (query.platform && query.platform !== 'all')
    params.append('platform', query.platform)
  if (query.search) params.append('search', query.search)
  if (query.sort) params.append('sort', query.sort)

  const suffix = params.toString()
  return requestJson<TopicListResponse>(`/api/v1/topics${suffix ? `?${suffix}` : ''}`, {
    method: 'GET',
    signal,
  }).then(parseTopicListResponse)
}

export async function getTopicDetail(
  id: string,
  signal?: AbortSignal,
): Promise<TopicList> {
  return requestJson<TopicList>(`/api/v1/topics/${id}`, {
    method: 'GET',
    signal,
  }).then(parseTopicList)
}

export async function createTopicList(data: CreateTopicListInput): Promise<TopicList> {
  return requestJson<TopicList>('/api/v1/topics', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
  }).then(parseTopicList)
}

export async function updateTopicList(data: UpdateTopicListInput): Promise<TopicList> {
  const { id, ...rest } = data
  return requestJson<TopicList>(`/api/v1/topics/${id}`, {
    method: 'PUT',
    body: JSON.stringify(rest),
    headers: { 'Content-Type': 'application/json' },
  }).then(parseTopicList)
}

export async function deleteTopicList(id: string): Promise<void> {
  return requestJson<void>(`/api/v1/topics/${id}`, { method: 'DELETE' })
}

export async function addKeywordsToList(
  id: string,
  keywords: string[],
): Promise<{ message: string; list: TopicList }> {
  return requestJson<{ message: string; list: TopicList }>(`/api/v1/topics/${id}/add`, {
    method: 'POST',
    body: JSON.stringify({ keywords }),
    headers: { 'Content-Type': 'application/json' },
  })
}
